import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <div className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Welcome to <span className="highlight">KURO</span></h1>
          <p className="hero-subtitle">Embark on an epic MapleStory V83 adventure</p>
          <div className="hero-buttons">
            <Link to="/rankings" className="btn btn-primary">
              View Rankings
            </Link>
            <a href="https://discord.gg/UF4QCTYEsN" target="_blank" rel="noopener noreferrer" className="btn btn-dark">
              Join Discord
            </a>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-content">
                <h3>Competitive Rankings</h3>
                <p>Compete with players around the world and climb to the top of our leaderboards.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-content">
                <h3>Active Community</h3>
                <p>Join our vibrant community of players and make new friends on your adventure.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-content">
                <h3>V83 Experience</h3>
                <p>Experience the classic V83 MapleStory gameplay with nostalgic features and balanced progression.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;